import Flickity from 'flickity';
import anime from 'animejs';
import { forEach } from 'lodash';
import Slider from 'shared/slider';
import { isLessThan } from '../shared/mq';

export default class Focus {
  constructor(root) {
    this.root = root;
    this.current = 0;

    this.contentSliderEl = this.root.querySelector('.u-focus__slider');
    this.imageSliderEl = this.root.querySelector('.u-slider');
    this.slides = this.root.querySelectorAll('.u-slider__slide');
    this.thumbsList = this.root.querySelector('.u-focus__thumbs__list');
    this.thumbs = this.root.querySelectorAll('.u-focus__thumbs__list > li');
    this.prevBtn = this.root.querySelector('.u-focus__thumbs .u-slider__pagination__prev');
    this.nextBtn = this.root.querySelector('.u-focus__thumbs .u-slider__pagination__next');
    this.currentPageEl = this.root.querySelector('.u-focus__thumbs .u-slider__pagination__pages__current');

    this.bind();
  }

  bind() {
    if (!this.slides.length) {
      return;
    }

    this.imageSlider = Slider.getInstanceByElement(this.imageSliderEl);
    this.contentSlider = new Flickity(this.contentSliderEl, {
      draggable: false,
      accessibility: false,
      prevNextButtons: false,
      pageDots: false,
    });

    forEach(this.thumbs, (thumb, index) => {
      thumb.addEventListener('click', () => this.select(index, true));
    });

    this.prevBtn && this.prevBtn.addEventListener('click', this.prev.bind(this));
    this.nextBtn && this.nextBtn.addEventListener('click', this.next.bind(this));
  }

  destroy() {
    // TODO
  }

  selectThumb(index) {
    forEach(this.thumbs, (thumb, i) => {
      const action = index === i ? 'add' : 'remove';
      thumb.classList[action]('u-focus__thumbs__active');
    });

    this.slideToThumb(index);
  }

  // Slide thumb list to show more thumbs
  slideToThumb(index) {
    const thumbWidth = 80;
    const containerEl = this.root.querySelector('.u-focus__thumbs__list-outer');

    if (isLessThan('medium')) {
      const offsetX = index * thumbWidth;

      containerEl.scroll({ top: 0, left: offsetX, behavior: 'smooth' });
    } else {
      // const maxY = (this.thumbs.length - 4) * thumbWidth;
      const offsetY = index * thumbWidth;

      // Do not move list past the last item
      // (list shows 4 items)
      // if (offsetY > maxY) {
      //   offsetY = maxY;
      // }

      containerEl.scroll({ top: offsetY, left: 0, behavior: 'smooth' });
    }
  }

  next() {
    if (!this.imageSlider.slidy._queue._isAnimating) {
      this.imageSlider.slidy.slideNext();
      this.select(this.current + 1);
    }
  }

  prev() {
    if (!this.imageSlider.slidy._queue._isAnimating) {
      this.imageSlider.slidy.slidePrev();
      this.select(this.current - 1);
    }
  }

  select(index, slideTo = false) {
    if (index === this.current) {
      return;
    }

    const total = this.contentSlider.slides.length;

    if (index < 0) {
      index = total - 1;
    }

    index = index % total;

    if (slideTo) {
      this.imageSlider.slidy.slideTo(index);
    }

    this.contentSlider.select(index);
    this.selectThumb(index);

    // Update current page nav
    if (this.currentPageEl) {
      const currentPage = index + 1;
      this.currentPageEl.innerHTML = currentPage < 10 ? `0${currentPage}` : currentPage;
    }

    this.current = index;
  }
}
